export default {
    login: {
        t01: '语言',
        t02: 'Netflix',
        t03: '请输入用户名',
        t04: '请输入密码',
        t05: '登录',
        t06: '注册',
        t07: '请输入手机号码',
        t08: '确认密码',
        t09: '请输入邀请码',
        t10: '注册账号',
        t11: '请输入确认密码',
        t13: '对电影的热爱可以让你在不经意间积累起丰富的财富。',
        t14: '登录成功',
        t15: '密码不一致',
        t16: '注册成功',
        t17: '网络错误',
        t18: '请求超时，请检查您的网络连接',
    },
    cover_info: {
        t01: '开始赚钱',
        t02: '充值金币',
        t03: '提现金币',
        t04: '证书'
    },
    cont: {
        t01: '选择语言',
        t02: '全部',
        t03: '待处理',
        t04: '已完成',
        t05: '冻结中',
        t06: '我的余额',
        t07: '未完成',
        t08: '订单总额',
        t09: '佣金',
        t10: '获得佣金',
        t11: '订单数量',
        t12: '可用余额',
        t13: '开始抢单',
        t14: '账户资金',
        t15: '提交订单',
        t16: '订单全部提交',
        t17: '抢单时间',
        t18: '订单号',
        t19: '订单总额',
        t21: '作品',
        t22: '演员',
        t23: '作品评论',
        t24: '取消',
        t25: '请选择评分',
        t26: '订单提交完成',
        t27: '获取订单',
        t28: '抢单成功',
        t29: '抢单失败,请稍后再试！'
    }
    ,
    user: {
        t1: '推广码',
        t2: '我的余额',
        t3: '可用余额',
        t4: '总收益',
        t5: '提现金币',
        t6: '充值记录',
        t7: '提现记录',
        t8: '账户明细',
        t9: '消息',
        t10: '绑定银行卡',
        t11: '修改密码',
        t12: '修改提现密码',
        t13: '邀请好友',
        t14: '选择语言',
        t15: '退出',
        t16: '提现',
        t17: '可提现金额',
        t18: '开户名',
        t19: '手机号',
        t20: '提现金额',
        t21: '提现',
        t22: '请输入提现金额',
        t23: '请输入资金密码',
        t24: '累计充值',
        t25: '系统消息',
        t26: '您的银行卡信息',
        t27: '银行列表',
        t28: '银行名称',
        t29: '真实姓名',
        t30: '银行卡号',
        t31: '联系电话',
        t32: '确定修改',
        t33: '请输入正确的银行卡号和绑定银行卡的IFSC号码，并且填写真实的姓名和真实手机号码，否则付款无法到达。',
        t34: '旧密码',
        t35: '新密码',
        t36: '确认密码',
        t37: '下一步',
        t38: '请牢记密码,如忘记密码,请联系客服。',
        t39: '复制邀请链接',
        t40: '邀请朋友获得佣金',
        t41: '充值',
        t42: '确定',
        t43: '取消',
        t44: '是否退出登录',
        t45: '充值金额',
        t46: '充值成功',
        t47: '审核通过',
        t48: '待审核',
        t49: '累计提现',
        t50: '请先设置提现密码',
        t51: '请输入旧密码',
        t52: '请输入新密码',
        t53: '请输入确认密码',
        t54: '两次密码输入不一致',
        t55: '复制成功',
        t56: '提现金额不能低于30元',
        t57: '成功发送，正在跳转',
        t58: '审核失败',
        t59: '设置头像',
        t60: '立即设置',
        t61: '设置成功',
        t62: '钱包审批通过后，需要登录取钱',
        t63: '提现到银行卡',
        t64: '提现到 USDT(比例 1:0.013)',
        t65: '银行账号',
        t66: '请输入正确的银行账号和绑定银行卡的IFSC号码，并且填写真实的姓名和真实手机号码，否则付款无法到达。',
        t67: '请先绑定银行卡',
        t68: '用户充值',
        t69: '用户接单',
        t70: '下级返佣',
        t71: '用户提现',
        t72: '余额宝转入',
        t73: '余额宝转出',
        t74: '余额宝收益',
        t75: '接单返佣',
        t76: '余额低于 30,无法继续交易,请联系客服人员处理',
        t77: '请输入银行名称',
        t78: '请输入银行账号',
        t80: '请输入真实姓名',
        t81: '请输入联系电话',
        t82: '请输入充值金额',
        t83: '复制',
        t84: '每日 100 佳：全球',
        t85: '试听',
        t86: '邮箱',
        t87: '请输入邮箱',
        t88: '银行代码',
        t89: '请输入银行代码',
        t90: '银行转账',
        t91: '1. 提款无需任何手续费。',
        t92: '2. 提款将在提款后 10 至 15 分钟内到账。非营业时间提款，款项将在下一个营业时间内到账。'
    },
    movie: {
        t01: '热门电影和电视节目',
        t02: '资金密码',
        t03: '订单差额',
        t04: '链上地址管理',
        t05: '请输入',
        t06: '请输入正确的链上地址与对应网络（如 ERC20/TRC20/BTC），否则付款/转账可能无法到达或导致资产丢失。',
        t07: '提现到链上地址',
        t08: '请添加',
        t09: '请添加链上地址',
    },
    langType: '中国大陆'
}
